import { IGlobalState } from '../../interfaces/state';

export const isSendingMessage = (state: IGlobalState) => {
  return state.gpt?.aiConsultant?.sending || false;
};